// extracted by mini-css-extract-plugin
export default {"thumbnailWidth":"180px","smallThumbnailWidth":"120px"};